import * as React from 'react';

const SvgGoogleCalendar = (props) => (
  <svg
    width={48}
    height={48}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_118_1087)">
      <path
        d="M36.6317 11.3683L25.2634 10.1052L11.3686 11.3683L10.1052 24L11.3683 36.6317L24 38.2107L36.6317 36.6317L37.8948 23.6844L36.6317 11.3683Z"
        fill="white"
      />
      <path
        d="M16.5506 30.9663C15.6065 30.3284 14.9527 29.397 14.5958 28.1653L16.7875 27.2622C16.9865 28.0201 17.3337 28.6074 17.8296 29.0242C18.3223 29.4411 18.9223 29.6463 19.6233 29.6463C20.3402 29.6463 20.9561 29.4284 21.4706 28.9926C21.9852 28.5567 22.2444 28.0009 22.2444 27.3284C22.2444 26.6401 21.9727 26.0778 21.4296 25.6422C20.8865 25.2066 20.2044 24.9884 19.3896 24.9884H18.1233V22.819H19.26C19.961 22.819 20.5517 22.6297 21.0317 22.2507C21.5117 21.8718 21.7517 21.3538 21.7517 20.6938C21.7517 20.1066 21.5369 19.639 21.1075 19.2886C20.6781 18.9382 20.1348 18.7614 19.4748 18.7614C18.8306 18.7614 18.3189 18.932 17.94 19.2762C17.561 19.6203 17.2862 20.0434 17.1127 20.5424L14.9433 19.6393C15.2306 18.8245 15.7581 18.1045 16.5317 17.4824C17.3054 16.8603 18.2937 16.5476 19.4937 16.5476C20.381 16.5476 21.18 16.7182 21.8875 17.0624C22.5948 17.4066 23.1506 17.8834 23.5517 18.4897C23.9527 19.099 24.1517 19.7814 24.1517 20.539C24.1517 21.3128 23.9654 21.9663 23.5927 22.5032C23.22 23.0401 22.7621 23.4505 22.2189 23.738V23.8674C22.9358 24.1674 23.52 24.6253 23.981 25.2411C24.4389 25.857 24.6693 26.5928 24.6693 27.4518C24.6693 28.3107 24.4514 29.078 24.0156 29.7507C23.5797 30.4234 22.9766 30.9538 22.2125 31.339C21.4452 31.7242 20.5831 31.9201 19.6262 31.9201C18.5179 31.9232 17.4948 31.6042 16.5506 30.9663Z"
        fill="#1A73E8"
      />
      <path
        d="M30 20.0906L27.6062 21.8306L26.4031 20.0054L30.72 16.8916H32.3748V31.5789H30V20.0906Z"
        fill="#1A73E8"
      />
      <path
        d="M36.6316 48L48 36.6317L42.3158 34.1055L36.6316 36.6317L34.1054 42.3159L36.6316 48Z"
        fill="#EA4335"
      />
      <path
        d="M8.8421 42.3157L11.3683 47.9999H36.6315V36.6316H11.3683L8.8421 42.3157Z"
        fill="#34A853"
      />
      <path
        d="M3.78936 0C1.69584 0 0 1.69584 0 3.78936V36.6314L5.68416 39.1577L11.3683 36.6314V11.3683H36.6314L39.1577 5.68416L36.6317 0H3.78936Z"
        fill="#4285F4"
      />
      <path
        d="M0 36.6316V44.2106C0 46.3043 1.69584 47.9999 3.78936 47.9999H11.3683V36.6316H0Z"
        fill="#188038"
      />
      <path
        d="M36.6317 11.3683V36.6314H48V11.3683L42.3159 8.84204L36.6317 11.3683Z"
        fill="#FBBC04"
      />
      <path
        d="M48 11.3683V3.78936C48 1.6956 46.3042 0 44.2107 0H36.6317V11.3683H48Z"
        fill="#1967D2"
      />
    </g>
    <defs>
      <clipPath id="clip0_118_1087">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgGoogleCalendar;
